<template>
  <div id="screenshotPC-wrap" >
   <tool    ref="tool">
    <template slot="title">PC品专截图</template>
  </tool>
   <task    ref="task"    :code="code"></task>
  </div>
</template>

<script>
import tool from '../../components/Tool.vue'
import task from '../../components/TaskList.vue'
import { authorityMixin } from '../../utils/mixin'
import { createJietuReq } from '../../api/auth.js'
export default {
  name: 'screenshotPC',
  components: {
   
  },
  mixins: [authorityMixin],
  components: {
    tool,
    task
  },
  data () {
    return {
      code:'getJietuReqs'
    }
  },
  watch: {
   
  },
  created () {
   
  },
   methods: {
    handleSubmit(){
      let keyWords =  this.$refs.tool.keyWords
       if(!(!keyWords||(keyWords&&keyWords.length===0))){
      let data ={
        uid:this.loginUser.uid,
        name:`PC品专截图`,
        keywords:keyWords.split('\n')
      }
      createJietuReq(data,{ simplify: false }).then(res=>{
      this.$message.success("任务提交成功")
      })
      }
      else{
        this.$message.error('请输入种子词,每一行一个词')
      }
    }
  }
}

</script>
<style lang='less'>
  #screenshotPC-wrap {
 display: flex;
      height: 100%;
      width: 100%;
      background-color: #fff;
  }
</style>
